import { useState } from "react";
import { ChevronDown, Search } from "lucide-react";
import { play as sfx, playHover } from "@/utils/sounds";

const StratagemPicker = ({ stratagems, value, search, onSearch, onChange }) => {
  const [open, setOpen] = useState(false);
  const selected = stratagems.find(s => s.id === value);

  return (
    <div className="relative" data-testid="filter-stratagem">
      <button
        onClick={() => { sfx("click"); setOpen(!open); }}
        onMouseEnter={playHover}
        className="w-full flex items-center justify-between bg-black/60 border border-white/10 px-3 py-2 text-sm font-data text-white hover:border-[#FFE800]/40 transition-colors duration-150"
        data-testid="stratagem-picker-toggle"
      >
        <span className="truncate">{selected ? selected.name : "Select stratagem..."}</span>
        <ChevronDown className={`h-4 w-4 text-gray-500 transition-transform duration-150 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute z-50 top-full left-0 right-0 mt-1 bg-[#0f0f10] border border-white/10 max-h-64 overflow-y-auto">
          <div className="sticky top-0 bg-[#0f0f10] p-2 border-b border-white/10">
            <div className="flex items-center gap-2 border border-white/10 px-2 py-1">
              <Search className="h-3 w-3 text-gray-500" />
              <input
                value={search}
                onChange={e => onSearch(e.target.value)}
                placeholder="Search..."
                className="bg-transparent text-xs font-data text-white outline-none flex-1"
                data-testid="stratagem-picker-search"
                autoFocus
              />
            </div>
          </div>
          {stratagems.length === 0 ? (
            <p className="p-3 text-xs text-gray-600">No matches</p>
          ) : (
            stratagems.map(s => (
              <button
                key={s.id}
                onClick={() => { sfx("click"); onChange(s.id); setOpen(false); onSearch(""); }}
                onMouseEnter={playHover}
                className={`w-full text-left px-3 py-2 text-xs font-data hover:bg-[#FFE800]/[0.06] hover:text-[#FFE800] transition-colors duration-100 ${
                  s.id === value ? "text-[#FFE800] bg-[#FFE800]/[0.03]" : "text-gray-300"
                }`}
                data-testid={`stratagem-option-${s.id}`}
              >
                <span>{s.name}</span>
                <span className="ml-2 text-gray-600">{s.category}</span>
              </button>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default StratagemPicker;
